// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzone {
    cursor: pointer;
    width: 100%;
    display: flex;
    place-content: center;
    flex-direction: column;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 20px;
    height: 100px;
    border: 2px dashed var(--colorBorder);
    border-radius: 4px;
    text-align: center;
    background-color: var(--colorDividerLight);
    transition: all 0.3s ease;
}

.dropzone:hover {
    border-color: var(--colorDivider);
    background-color: var(--colorSecondaryFocused);
}

.dropzone-active {
    border-color: var(--colorPrimary);
    border-width: 3px;
    background-color: var(--colorDivider);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.dropzone-label {
    margin-bottom: 10px;
    font-weight: normal;
}

.dropzone:focus {
    outline: 2px solid var(--colorPrimary);
    outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./../../../Components/Fragment/Dropzone/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,8CAA8C;AAClD;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;IACjB,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;AACvB","sourcesContent":[".dropzone {\r\n    cursor: pointer;\r\n    width: 100%;\r\n    display: flex;\r\n    place-content: center;\r\n    flex-direction: column;\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n    margin-bottom: 20px;\r\n    height: 100px;\r\n    border: 2px dashed var(--colorBorder);\r\n    border-radius: 4px;\r\n    text-align: center;\r\n    background-color: var(--colorDividerLight);\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.dropzone:hover {\r\n    border-color: var(--colorDivider);\r\n    background-color: var(--colorSecondaryFocused);\r\n}\r\n\r\n.dropzone-active {\r\n    border-color: var(--colorPrimary);\r\n    border-width: 3px;\r\n    background-color: var(--colorDivider);\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.dropzone-label {\r\n    margin-bottom: 10px;\r\n    font-weight: normal;\r\n}\r\n\r\n.dropzone:focus {\r\n    outline: 2px solid var(--colorPrimary);\r\n    outline-offset: 2px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
